import React, { useState, useContext } from "react";
import {
  Button,
  FlexBox,
  H2,
  H3,
  Li,
  Link,
  Typography,
  Ul,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogNav,
} from "@vp/swan";
import {
  Placeholder,
  PlaceholderGroupMember,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import { PluginPlaceholderContext } from "../../pluginsInfrastructure/PluginPlaceholderContextProvider";

import "../../styles/DebugPluginComponent.scss";

export interface DebugPluginPlaceholderProps extends React.PropsWithChildren {
  placeholderType: Placeholder | PlaceholderGroupMember;
}

export const DebugPluginPlaceholder: React.FC<DebugPluginPlaceholderProps> = ({
  placeholderType,
  children,
}) => {
  const { level, componentNames: parentComponentNames } = useContext(PluginPlaceholderContext);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const detailFlyout = (
    <ModalDialog
      isOpen={isDialogOpen}
      onRequestDismiss={() => {
        setIsDialogOpen(false);
      }}
      variant="panel-right"
    >
      <ModalDialogContent>
        <ModalDialogNav>
          <ModalDialogCloseButton />
        </ModalDialogNav>
        <ModalDialogBody>
          <FlexBox flexDirection={"column"}>
            <H2 fontSize={"small"} mr={"3"}>
              {`Debug: placeholder ${placeholderType}`}
            </H2>
            {parentComponentNames?.length > 0 && (
              <>
                <H3 fontSize={"xsmall"}>Parent components:</H3>
                <Ul skin="minimal">
                  {parentComponentNames.map(name => (
                    <Li fontSize={"xsmall"} ml={"3"}>
                      {name}
                    </Li>
                  ))}
                </Ul>
              </>
            )}
          </FlexBox>
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
  );
  return (
    <div className="debug-plugin-placeholder-container">
      <FlexBox className="debug-plugin-placeholder" flexDirection={"column"}>
        <FlexBox alignItems={"center"} justifyContent={"space-between"}>
          <Typography fontSize={"xsmall"} mr={"3"}>
            {`Placeholder: ${placeholderType}`}
          </Typography>
          <Link
            render={p => (
              <Button
                skin="link"
                className={p.className}
                onClick={() => setIsDialogOpen(!isDialogOpen)}
              >
                {p.children}
              </Button>
            )}
          >
            <Typography fontSize={"xsmall"}>{`Level: ${level}`}</Typography>
          </Link>
        </FlexBox>
      </FlexBox>
      {detailFlyout}
      {children}
    </div>
  );
};
